module.exports = __webpack_public_path__ + "static/media/25.cfc13d1e.mp3";